module.exports = __webpack_public_path__ + "img/chartbar_icon.98c068af.svg";